import { useFeedbackAttachments } from "@/hooks/use-feedback-attachments";
import { SrIcon } from "@/components/ui/SrIcon";

/**
 * Viser feedback-vedlegg (screenshots + PDF-er) på et feedback-kort i
 * /feedback. Henter signerte URL-er for den private feedback-attachments-bucketen
 * (admin-lese-policy). Bilder vises inline, andre filer som lenke.
 */
export function FeedbackAttachments({ paths }: { paths: string[] }) {
  const { data: attachments = [], isLoading } = useFeedbackAttachments(paths);

  if (paths.length === 0) return null;
  if (isLoading) {
    return <p className="text-xs text-muted-foreground">Laster vedlegg…</p>;
  }
  if (attachments.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {attachments.map((a) =>
        a.isImage ? (
          <a key={a.path} href={a.url} target="_blank" rel="noreferrer" title={a.name}>
            <img
              src={a.url}
              alt={a.name}
              className="max-h-44 rounded border object-contain hover:opacity-90 transition-opacity"
            />
          </a>
        ) : (
          <a
            key={a.path}
            href={a.url}
            target="_blank"
            rel="noreferrer"
            className="text-xs text-primary hover:underline inline-flex items-center gap-1"
          >
            <SrIcon name="file-text" className="w-3.5 h-3.5" />
            {a.name}
          </a>
        ),
      )}
    </div>
  );
}
